/**
 * /app/messages — Legacy redirect to /app/inbox per spec §3.1.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/messages')({
  beforeLoad: () => {
    throw redirect({ to: '/app/inbox' });
  },
  component: () => null,
});
